import React from 'react';

type Props = {
  children: string;
  search: string;
};

export const HighlightMatchingText = ({ children, search }: Props) => {
  if (!search) return children;

  const parts = children.split(new RegExp(`(${search})`, 'gi'));
  return <>{parts.map((part, index) => (part.toLowerCase() === search.toLowerCase() ? <mark key={index}>{part}</mark> : <React.Fragment key={index}>{part}</React.Fragment>))}</>;
};
